// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'

import VueRouter from 'vue-router'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'
import ElementUI from 'element-ui'
import OrderBlock from '@/components/OrderBlock.vue'
import VueApollo from 'vue-apollo'
import VueRouterUserRoles from 'vue-router-user-roles'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import Autocomplete from 'v-autocomplete'
import VueTimers from 'vue-timers'
import VueTheMask from 'vue-the-mask'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import vSelect from 'vue-select'
import lodash from 'lodash'
import Notifications from 'vue-notification'
import moment from './moment'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import vuescroll from 'vuescroll/dist/vuescroll-native'
import YmapPlugin from 'vue-yandex-maps'
import userInfo from './plugins/userInfo'
import { store } from './vuex/store'
import apolloClient from './apolloClient'
import ymapsSettings from './configs/ymapsSettings'
import log from './plugins/log'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import '@/assets/css/vue2-perfect-scrollbar-theme.css'
import 'v-autocomplete/dist/v-autocomplete.css'
import 'vue-select/dist/vue-select.css'
import 'vuescroll/dist/vuescroll.css'
import 'element-ui/lib/theme-chalk/index.css'

/**
 * Поскольку нужно загрузить ключи API Яндекса "синхронно" до инициализации
 * плагина карт, оборачиваем всю инициализацию Vue в асинхронную функцию и
 * благополучно пользуемся await.
 */
async function init() {

Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

moment.tz.setDefault('Asia/Yekaterinburg')

Vue.filter('timeByFullTime', function (value) {
  if (!value) { return '' }
  return moment(value, 'HH:mm:ss').format('HH:mm')
})

Vue.filter('time', function (value) {
  if (!value) { return '' }
  return moment(value).format('HH:mm')
})

Vue.filter('timeChoose', function (value) {
  value = moment(value, 'hh:mm:ss')
  if (value.toString() === 'Invalid date') { return null }
  return value.format('HH:mm')
})

Vue.filter('date', function (value) {
  if (!value) { return '' }
  return moment(value).format('DD.MM.YYYY')
})

Vue.filter('dateTime', function (value) {
  if (!value) { return '' }
  return moment(value).format('HH:mm DD.MM.YYYY')
})

Vue.filter('diffTime', function (value, toTime) {
  if (!value) { return '' }
  if (toTime) { return moment(toTime).subtract(String(value)) }
  return moment().subtract(value).format('HH:mm')
})

Vue.filter('currencydecimal', function (value) {
  return value.toFixed(2)
})

Vue.use(PerfectScrollbar)
Vue.use(VueTheMask)
Vue.use(vuescroll)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(ElementUI, { locale })
Vue.component('order-block', OrderBlock)
Vue.component('icon', Icon)
Vue.component('datepicker', Datepicker)
Vue.component('v-select', vSelect)
Vue.config.productionTip = false
Vue.use(VueRouterUserRoles, { router })
Vue.use(Autocomplete)
Vue.use(VueTimers)
Vue.use(Notifications)
Vue.use(VueApollo)
Vue.use(userInfo, { store: store })
Vue.use(log)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: 'loading',
    $query: {
      fetchPolicy: 'cache-and-network'
    }
  },
  errorHandler(error) {
    console.log('Vue-Apollo global error handler', error)
  }
})

const ympsStngs = await ymapsSettings()
Vue.use(YmapPlugin, ympsStngs)

const test = function (test: number) {
  return false
}
/* eslint-disable no-new */
// @ts-ignore
new Vue({
  el: '#app',
  // @ts-ignore
  store,
  router,
  created() {
    this.registerWindowEvents()

    setInterval(function (that) {
      that.$userControl.validateRelevanceToken()
    }, 10000, this)

    setInterval(function (that) {
      if (that.$userControl.jwtParsed) {
        that.$userControl.checkUserActivity()
      }
    }, 5000, this)
  },
  methods: {
    registerWindowEvents() {
      let wEvents = ["visibilitychange", "mousemove", "touchmove", "click", "scroll", "load"]
      for (let wEvent of wEvents) {
        document.addEventListener.call(window, wEvent, event => {
          if (event.type === 'visibilitychange' && !document.hidden || event.type !== 'visibilitychange') {
            this.$userControl.userTriggered(event)
          }
        })
      }
    }
  },
  apolloProvider: apolloProvider,
  components: { App },
  template: '<App/>'
})

}

init()



// WEBPACK FOOTER //
// ./src/main.ts